import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../i18n/languages';

export function LanguageToggle() {
  const { t, i18n } = useTranslation();

  const handleChange = (_: unknown, language: string | null) => {
    if (!language) return;
    i18n.changeLanguage(language);
  };

  return (
    <ToggleButtonGroup
      value={i18n.resolvedLanguage ?? DEFAULT_LANGUAGE}
      exclusive
      onChange={handleChange}
      aria-label={t('common.language')}
    >
      {SUPPORTED_LANGUAGES.map((language) => (
        <ToggleButton key={language} value={language}>
          {t(`languages.${language}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
